export const IMGS = {
  jacket:
    "https://images.unsplash.com/photo-1781779766496-73dcf6b23285?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjbG90aGVzJTIwaGFuZ2luZyUyMHJhY2t8ZW58MHx8fHwxNzkzNjAzNjg4fDA&ixlib=rb-4.1.0&q=85",
  rack: "/images/site-idea.jpg",
  hoodie: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?auto=format&fit=crop&q=80",
  tshirt: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&q=80",
  pattern: "/images/site-design.jpg",
  fabric:
    "https://images.unsplash.com/photo-1517146783983-418c681b56c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxmYWJyaWMlMjByb2xsc3xlbnwwfHx8fDE3OTM2MDM2ODh8MA&ixlib=rb-4.1.0&q=85",
  sewing:
    "https://images.unsplash.com/photo-1560796952-f1c9b838544c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxzZXdpbmclMjBtYWNoaW5lJTIwcHJvZHVjdGlvbnxlbnwwfHx8fDE3OTM2MDM2ODh8MA&ixlib=rb-4.1.0&q=85",
  qc:
    "https://images.unsplash.com/photo-1741176505800-caaa3a52631a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxxdWFsaXR5JTIwY29udHJvbCUyMGluc3BlY3Rpb24lMjBjbG90aGluZ3xlbnwwfHx8fDE3OTM2MDM2OTN8MA&ixlib=rb-4.1.0&q=85",
  labels: "/images/site-labels.jpg",
  packing:
    "https://images.unsplash.com/photo-1759563874676-d551447de3a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxmb2xkaW5nJTIwY2xvdGhlcyUyMHBhY2thZ2luZ3xlbnwwfHx8fDE3OTM2MDM2ODh8MA&ixlib=rb-4.1.0&q=85",
  denim:
    "https://images.pexels.com/photos/15870127/pexels-photo-15870127.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  active:
    "https://images.unsplash.com/photo-1699065186471-a5d578db941b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxhY3RpdmV3ZWFyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkzNjAzNjg4fDA&ixlib=rb-4.1.0&q=85",
  shirt:
    "https://images.unsplash.com/photo-1657180881998-c8a03ef22695?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxjcmlzcCUyMHdoaXRlJTIwc2hpcnQlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTM2MDM2OTR8MA&ixlib=rb-4.1.0&q=85",
  factory: "/images/site-factory.jpg",
  shipping: "/images/site-shipping.png",
};
